import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConnectionService } from '../../../services/connection-service';
import { Broadcaster } from '../../../components/broadcaster/index';

@Component({
    selector: 'view', templateUrl: './view.html',
    standalone: false
})
export class ViewComponent {
  iframeLink: SafeResourceUrl;
  metabaseParams: { [key: string]: string } = {};
  signedLink: string;

  static parameters: any = [ActivatedRoute, ConnectionService, DomSanitizer];
  constructor(private route: ActivatedRoute,
              private conn: ConnectionService,
              private sanitizer: DomSanitizer,
              private broadcaster: Broadcaster) {}

  async ngOnInit(): Promise<any> {
    const id: string = this.route.parent.snapshot.params.id;
    const params: { [key: string]: string } = {};
    Object.keys(this.route.parent.snapshot.queryParams).forEach((key: string): void => {
      if (key !== 'id') {
        params[key] = this.route.parent.snapshot.queryParams[key];
      }
    });
    const sessionToken: string = this.conn.getCurrentUser().getSessionToken();
    const response = await this.conn.serverApi.getEmbeddedLinkSignedURL({ id, params }, sessionToken);
    const url: string = response.data.data.url;
    this.signedLink = url;
    this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    window.addEventListener('message', this.handleMetabaseMessage.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleMetabaseMessage.bind(this));
  }

  handleMetabaseMessage(event: MessageEvent): void {
    const urlParams = new URLSearchParams(event.data?.metabase?.location?.search);
    if (urlParams.size > 0) {
      urlParams.forEach((value, key) => {
        this.metabaseParams[key] = value;
      });
      this.broadcaster.broadcast('paramsChanged', { metabaseParams: this.metabaseParams, metabaseLink: this.signedLink });
    }
  }
}
